import React, { useState } from 'react';
import { Target, GitBranch, Sparkles } from 'lucide-react';
import GoalsPanel from './GoalsPanel';
import ScenariosPanel from './ScenariosPanel';

/**
 * M7 — Decision Intel
 *
 * Wraps Goals (M7.1) and Scenarios (M7.2) into one module — matches the
 * saarv-mrv-beta module layout where Decision Intel covers goals/targets,
 * scenarios, pathways, and intervention modelling.
 */

const SUB_TABS = [
  { id: 'goals',     label: 'Goals & Targets',       Icon: Target },
  { id: 'scenarios', label: 'Scenarios & Pathways',  Icon: GitBranch },
];

export default function DecisionPanel({ siteId }) {
  const [activeSubTab, setActiveSubTab] = useState('goals');

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Decision Intelligence</h2>
          <div className="text-xs text-gray-500">M7 — Net-zero goals, what-if scenarios, decarbonisation pathways</div>
        </div>
      </div>

      {/* Sub-tabs */}
      <div className="border-b border-gray-200 mb-4">
        <nav className="-mb-px flex gap-2">
          {SUB_TABS.map(({ id, label, Icon }) => (
            <button
              key={id} type="button" onClick={() => setActiveSubTab(id)}
              className={`py-2 px-3 inline-flex items-center gap-1 border-b-2 text-sm font-medium ${
                activeSubTab === id
                  ? 'border-emerald-600 text-emerald-700'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className="w-4 h-4" /> {label}
            </button>
          ))}
        </nav>
      </div>

      {activeSubTab === 'goals' && <GoalsPanel siteId={siteId} />}
      {activeSubTab === 'scenarios' && <ScenariosPanel siteId={siteId} />}
    </div>
  );
}
